var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('SiteNav'),_vm._m(0),_c('HelloWorld',{attrs:{"msg":""}}),_c('router-view'),_c('SiteBottom')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('img',{attrs:{"alt":"Vue logo","src":require("./assets/logo_heyue.png")}})])
}]

export { render, staticRenderFns }